import React, { PropsWithChildren, useContext, useState } from 'react';
import { useAsyncCallback, UseAsyncReturn } from 'react-async-hook';
import { connectApiAxios, leadApiAxios } from '../config/axios';

type LeadServiceContextProps = {
  generateCustomer: UseAsyncReturn<any, any>;
  updateCustomer: UseAsyncReturn<any, [payload: any, customerId: string]>;
  generateCompany: UseAsyncReturn<any, [payload: any, customerId: string]>;
  generateLead: UseAsyncReturn<any, any>;
  loading: boolean;
  setLoading: (val: boolean) => void;
};

const LeadServiceContext = React.createContext<LeadServiceContextProps>(
  {} as any
);

const LeadServiceContextProvider: React.FC<PropsWithChildren<any>> = (props) => {
  const { children } = props;

  const [loading, setLoading] = useState<boolean>(false);

  const x_api_key = process.env['REACT_APP_X_API_KEY'] || '';

  const generateCustomer = useAsyncCallback(async (payload) => {
      const { data } = await connectApiAxios.post<any>(
          `/api/customers`, payload,
          {
              headers: {
                  'x-api-key': x_api_key
              }
          }
      );

      return data;
  });

  const updateCustomer = useAsyncCallback(async (payload, customerId) => {
    const { data } = await connectApiAxios.patch<any>(
      `/api/customers/${customerId}`, payload,
      {
        headers: {
          'x-api-key': x_api_key
        }
      }
    );

    return data;
  });

  const generateCompany = useAsyncCallback(async (payload, customerId) => {
    const { data } = await connectApiAxios.post<any>(
        `/api/customers/${customerId}/companies`, payload,
        {
            headers: {
                'x-api-key': x_api_key
            }
        }
    );

    return data;
});

  const generateLead = useAsyncCallback(async (payload) => {
    const { data } = await leadApiAxios.post<any>(
      `/leads`, payload
    );
    return data;
  });

  return (
    <LeadServiceContext.Provider
      value={{
        generateCustomer,
        updateCustomer,
        generateCompany,
        generateLead,
        loading,
        setLoading,
      }}
    >
      {children}
    </LeadServiceContext.Provider>
  );
};

export const useLeadService = () => useContext(LeadServiceContext);

export default LeadServiceContextProvider;
